import { PROVIDER_LOGOS, ProviderType } from './types'

export const getProviderLogo = (providerId: ProviderType) =>
  PROVIDER_LOGOS[providerId]
export const configuredProvidersList = Object.keys(PROVIDER_LOGOS)
